import React, { Fragment } from "react";
import cx from "classnames";

// Provide a function which returns a HTML structure based on the row-information from the overview
import { TextFilter } from "../../components/Overview/Filters/TextFilter";
import { getCompetenceProfiles } from "../../queries/competence_profiles";
import moment from "moment";
import { DropDownFilter } from "../../components/Overview/Filters/DropdownFilter";
import { DropDownFilterFull } from "../../components/Overview/Filters/DropdownFilterFull";
import { CheckboxFilter } from "../../components/Overview/Filters/CheckboxFilter";
import { IconTitle } from "../../components/Overview/Titles/IconTitle";
import { employerSpecificTooltipText } from "../courses/components/tooltips";
import { DropdownFilterInput } from "../../components/Overview/Filters/DropdownFilterInput";
import { DropDownFilterMinimal } from "../../components/Overview/Filters/DropdownFilterMinimal";
import { AutocompleteFilter } from "../../components/Overview/Filters/AutocompleteFilter";

const lookup = {};

// build LUT based on options and info as to prevent walking through the option and finding it every time
const typeToString = (key, options) => {
    if (lookup?.[key]) {
        return lookup?.[key];
    }

    lookup[key] = options.find((o) => o.slug === key)?.name || "-";
    return lookup[key];
};

export const RowStructure = (props) => {
    const minMaxDateText = (minDate, maxDate) => {
        const min = minDate ? moment(minDate, "YYYY-MM-DD") : false;
        const max = maxDate ? moment(maxDate, "YYYY-MM-DD") : false;

        if (min && max) {
            return `Beschikbaar tussen ${min.format("D MMM", ["nl"])} en ${max.format("D MMM", ["nl"])}`;
        }
        if (min && !max && min > moment()) {
            return `Beschikbaar vanaf ${min.format("D MMM", ["nl"])}`;
        }
        if (!min && max) {
            return `Beschikbaar tot ${max.format("D MMM", ["nl"])}`;
        }
    };

    const type = typeToString(props.type, props.contextData?.typeOptions);

    return (
        <tr
            key={props.uuid}
            className={cx("competence-selector__row", {
                "competence-selector__row--selected": props.uuid === props?.contextData?.competenceProfileUUID
            })}
            onClick={() => props?.contextData?.selectRow && props.contextData.selectRow(props)}
        >
            <td className={"competence-selector__cell"} title={props?.course_name || props?.name}>
                <div className={"overview-redux__truncated-text"}>
                    <div className={"competence-selector__title"}>{props?.course_name || props?.name}</div>
                    <div className={"competence-selector__date"}>{minMaxDateText(props.min_date, props.max_date)}</div>
                </div>
            </td>
            {/*<td className={"competence-selector__cell"}>*/}
            {/*    {props.code}*/}
            {/*</td>*/}
            <td className={"competence-selector__cell"}>{type}</td>
            <td className={"competence-selector__cell"}>{props.repetition ? "Herhaling" : "Basis"}</td>
            <td className={"competence-selector__cell competence-selector__cell--center"}>
                <div className={"flag"} lang={props.language} />
            </td>
            {/*<td className={"competence-selector__cell competence-selector__cell--center"}>*/}
            {/*    {props.repetition && <i className="fa fa-check competence-selector__check-icon" title={"Is een herhaling"}/>}*/}
            {/*</td>*/}
            <td className={"competence-selector__cell competence-selector__cell--center"}>
                {props.contains_elearning && <i className="fa fa-check competence-selector__check-icon" title={"Bevat e-learning"} />}
            </td>
            <td className={"competence-selector__cell competence-selector__cell--center"}>
                {props.allow_employer_specific && <i className="fa fa-check competence-selector__check-icon" title={"Mag bedrijfsspecifiek zijn"} />}
            </td>
            {props?.columns.some((col) => col.columnIdentifier === "trainers") && (
                <td className={"competence-selector__cell competence-selector__cell--center"}>
                    {props.trainers?.includes(props?.contextData?.trainer?.uuid) && (
                        <i className="fa fa-check competence-selector__check-icon" title={"Is opleiderspecifiek"} />
                    )}
                </td>
            )}
        </tr>
    );
};

export const CompetenceProfileOverviewDefinitionBase = {
    queryFn: getCompetenceProfiles,
    displayFake: true,
    displaySummary: true,
    RowStructure,
    search: {},
    columns: [
        {
            title: "Naam",
            columnIdentifier: "search",
            placeholder: "Type cursus, title (voor opleider), beschikbaarheid, ...",
            orderable: true,
            Filter: TextFilter
        },
        // {
        //     title: "Code",
        //     columnIdentifier: "code",
        //     placeholder: "Cursuscode",
        //     orderable: true,
        //     Filter: TextFilter,
        // },
        {
            title: "Type",
            columnIdentifier: "type",
            Filter: DropdownFilterInput,
            orderable: true,
            FilterOptions: {
                optionContextIdentifier: "typeOptions"
            }
        },
        {
            title: "Soort",
            columnIdentifier: "repetition",
            Filter: AutocompleteFilter,
            orderable: true,
            placeholder: "Kies optie",
            FilterOptions: {
                options: [
                    {
                        value: "false",
                        name: <>Basis</>
                    },
                    {
                        value: "true",
                        name: <>Herhaling</>
                    }
                ]
            }
        },
        {
            title: "Taal",
            columnIdentifier: "language",
            Filter: DropDownFilterMinimal,
            orderable: true,
            FilterOptions: {
                classNamePrefix: "flag",
                options: [
                    {
                        slug: "nl",
                        name: (
                            <>
                                <div className={"flag"} lang={"nl"} />
                            </>
                        )
                    },
                    {
                        slug: "en",
                        name: (
                            <>
                                <div className={"flag"} lang={"en"} />
                            </>
                        )
                    }
                ]
            }
        },
        // {
        //     columnIdentifier: "repetition",
        //     orderable:  false,
        //     Title: IconTitle,
        //     TitleOptions: {
        //         icon: "repeat",
        //         text: <>
        //             <strong>Is een herhaling</strong>
        //             <p className={"paragraph"}/>
        //         </>
        //     },
        //     Filter: CheckboxFilter,
        //     FilterOptions: {
        //         falseValue: "",
        //     }
        // },
        {
            columnIdentifier: "contains_elearning",
            orderable: false,
            Title: IconTitle,
            TitleOptions: {
                icon: "mortar-board",
                text: (
                    <>
                        <strong>E-learning</strong>
                        <p className={"paragraph"} />
                    </>
                )
            },
            Filter: CheckboxFilter,
            FilterOptions: {
                falseValue: ""
            }
        },
        {
            columnIdentifier: "allow_employer_specific",
            orderable: false,
            Title: IconTitle,
            TitleOptions: {
                icon: "building",
                text: (
                    <>
                        <strong>Bedrijfsspecifiek</strong>
                        <p className={"paragraph"}>{employerSpecificTooltipText}</p>
                    </>
                )
            },
            Filter: CheckboxFilter,
            FilterOptions: {
                falseValue: ""
            }
        },
        {
            columnIdentifier: "trainers",
            orderable: false,
            Title: IconTitle,
            TitleOptions: {
                icon: "group",
                text: (
                    <>
                        <strong>Opleiderspecifiek</strong>
                        <p className={"paragraph"} />
                    </>
                )
            },
            Filter: CheckboxFilter,
            FilterOptions: {
                optionContextIdentifier: "trainer",
                // trueValue: "",
                trueValueIdentifier: "uuid",
                falseValue: ""
                // falseValueIdentifier: "uuid",
            }
        }
    ],
    defaults: {
        ordering: {
            columnIdentifier: "search",
            direction: ""
        },
        pagination: {
            cursorPaginator: {
                offset: 0,
                size: 8
            }
        },
        filter: {
            is_active: 1,
            trainers: "",
            contains_elearning: "",
            allow_employer_specific: ""
        }
    }
};
